import React from 'react';
import { TEAMS } from '../teams';

export default function TextCircle({ teamName }: { teamName: string }) {
  let team = TEAMS[teamName];

  return (
    <svg
      viewBox="0 0 100 100"
      style={{ width: '100%', height: '100%' }}
      role="img"
      aria-label={team.endzone_abbreviation}
    >
      <circle cx="50" cy="50" r="50" fill={`#${team.endzone_hex_color}`} />
      <text
        x="50"
        y="55"
        textAnchor="middle"
        fill="#FFFFFF"
        fontFamily='"GothamNarrow-Bold", sans-serif'
        fontSize="32"
        dominantBaseline="middle"
      >
        {team.endzone_abbreviation}
      </text>
    </svg>
  );
}
